import React from 'react'
import { LinearProgress, Box, Typography } from '@mui/material';

export const CheckingAuth = () => {

    return (
        <Box
            sx={{
                width: 'min(360px, calc(100vw - 40px))',
                p: 3,
                borderRadius: 2,
                backgroundColor: '#2b2b2b',
                border: '1px solid #ffffff',
                boxShadow: '0 16px 40px rgba(0, 0, 0, 0.3)',
            }}
        >
            <Typography
                sx={{ color: '#f0f0f0', fontWeight: 600, mb: 0.5 }}
            >
                Un momento
            </Typography>

            <Typography
                sx={{ color: '#ffffff', fontSize: 14, mb: 2.5 }}
            >
                Cargando información...
            </Typography>

            <LinearProgress
                sx={{
                    height: 4,
                    borderRadius: 2,
                    backgroundColor: '#4a4a4a',
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: '#b59456',
                    },
                }}
            />
        </Box>
    );
}
